import { useMutation } from '@tanstack/react-query';
import { t } from 'i18next';
import { enqueueSnackbar } from 'notistack';
import { PasswordFormData } from '../components/organisms/password-forms/BasePasswordForm';
import { QUERY_KEYS } from '../constants';
import { postData } from '../utils/api';
import { useRoles } from '../hooks/useRoles';

export const useUpdatePassword = () => {
  const { isPlayer } = useRoles();
  const endpoint = isPlayer ? 'customer/change-password' : 'agent/change-password';
  return useMutation({
    mutationKey: [QUERY_KEYS.updatePassword],
    mutationFn: (settings: PasswordFormData) => {
      return postData(endpoint, { password: settings.password }, 'crm');
    },
    onSuccess: () => {
      enqueueSnackbar(t('register.validation.passwordUpdatedSuccessfully'), { variant: 'success' });
    },
    onError: () => {
      enqueueSnackbar(t('unexpectedError'), { variant: 'error' });
    },
  });
};
